import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/menu.svg';
import { Icon } from '../Icon/Icon';
export const MenuIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
